/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerGetProjectEffectivePrecedenceOrdersQueryResponse, GroupsControllerGetProjectEffectivePrecedenceOrdersPathParams, GroupsControllerGetProjectEffectivePrecedenceOrdersQueryParams, GroupsControllerGetProjectEffectivePrecedenceOrders401, GroupsControllerGetProjectEffectivePrecedenceOrders403, GroupsControllerGetProjectEffectivePrecedenceOrders404 } from "../../models/documentGroupsController/GroupsControllerGetProjectEffectivePrecedenceOrders";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { groupsControllerGetProjectEffectivePrecedenceOrders } from "../../clients/document-groupsService/groupsControllerGetProjectEffectivePrecedenceOrders";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const groupsControllerGetProjectEffectivePrecedenceOrdersQueryKey = (projectId: GroupsControllerGetProjectEffectivePrecedenceOrdersPathParams["projectId"], params: GroupsControllerGetProjectEffectivePrecedenceOrdersQueryParams = {}) => [{
  url: '/api/v1/documents/groups/projects/:projectId/effective-precedence-orders',
  params: {
    projectId: projectId
  }
}, ...(params ? [params] : [])] as const;
export type GroupsControllerGetProjectEffectivePrecedenceOrdersQueryKey = ReturnType<typeof groupsControllerGetProjectEffectivePrecedenceOrdersQueryKey>;
export function groupsControllerGetProjectEffectivePrecedenceOrdersQueryOptions(projectId: GroupsControllerGetProjectEffectivePrecedenceOrdersPathParams["projectId"], params?: GroupsControllerGetProjectEffectivePrecedenceOrdersQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = groupsControllerGetProjectEffectivePrecedenceOrdersQueryKey(projectId, params);
  return queryOptions<GroupsControllerGetProjectEffectivePrecedenceOrdersQueryResponse, ResponseErrorConfig<GroupsControllerGetProjectEffectivePrecedenceOrders401 | GroupsControllerGetProjectEffectivePrecedenceOrders403 | GroupsControllerGetProjectEffectivePrecedenceOrders404>, GroupsControllerGetProjectEffectivePrecedenceOrdersQueryResponse, typeof queryKey>({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return groupsControllerGetProjectEffectivePrecedenceOrders(projectId, params, config);
    }
  });
}

/**
 * @description Partitions the project's stated precedence clauses into independent chains (governing documents linked by a shared ORDER_OF_PRECEDENCE or CONTRACT_SET group) and resolves each: a clause loses when another clause's governing document outranks its own in a shared ORDER_OF_PRECEDENCE group, and inferred clauses lose to user-created or verified ones. RESOLVED chains carry the effective clause; UNRESOLVED chains carry every surviving candidate and never guess. Lineage records each defeat with its citation. Derived at read time, never stored. A project with no clauses returns an empty collection.
 * @summary Derive the effective orders of precedence for a project, one per chain
 * {@link /api/v1/documents/groups/projects/:projectId/effective-precedence-orders}
 */
export function useGroupsControllerGetProjectEffectivePrecedenceOrders<TData = GroupsControllerGetProjectEffectivePrecedenceOrdersQueryResponse, TQueryData = GroupsControllerGetProjectEffectivePrecedenceOrdersQueryResponse, TQueryKey extends QueryKey = GroupsControllerGetProjectEffectivePrecedenceOrdersQueryKey>(projectId: GroupsControllerGetProjectEffectivePrecedenceOrdersPathParams["projectId"], params?: GroupsControllerGetProjectEffectivePrecedenceOrdersQueryParams, options: {
  query?: Partial<QueryObserverOptions<GroupsControllerGetProjectEffectivePrecedenceOrdersQueryResponse, ResponseErrorConfig<GroupsControllerGetProjectEffectivePrecedenceOrders401 | GroupsControllerGetProjectEffectivePrecedenceOrders403 | GroupsControllerGetProjectEffectivePrecedenceOrders404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? groupsControllerGetProjectEffectivePrecedenceOrdersQueryKey(projectId, params);
  const query = useQuery({
    ...groupsControllerGetProjectEffectivePrecedenceOrdersQueryOptions(projectId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GroupsControllerGetProjectEffectivePrecedenceOrders401 | GroupsControllerGetProjectEffectivePrecedenceOrders403 | GroupsControllerGetProjectEffectivePrecedenceOrders404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}